import React from "react"
import styled, { css } from 'styled-components'
import { Title, Item } from '../../../shared/Section'
import LinkButton from '../../../shared/Buttons/LinkButton'

import map from '../../../../images/map.svg'

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`
const TextArea = styled.div`
  flex: 1 auto;
  padding-bottom: 4.0rem;
`

const MapArea = styled.div`
  width: 258px;
  height: auto;
`

const Place = styled.h3`
  ${({ theme: { breakpoints }}) => css`
    font-size: 1.8rem;
    span {
      display: inline-block;
    }
    @media (min-width: ${breakpoints.md}px) {
      font-size: 2.2rem;
    }
  `}
`

const Address = styled.div`
  padding: 2.4rem 0 2.4rem;
`

const Access = () => {
  return (
    <>
      <Title>Access</Title>
      <Item>
        <Wrapper>
          <TextArea>
            <Place><span>横浜赤レンガ倉庫１号館</span> <span>2Fスペース / 3Fホール</span></Place>
            <Address>
              <p>〒231-0001</p>
              <p>神奈川県横浜市中区新港1-1-1</p>
            </Address>
            <LinkButton href={"https://www.yokohama-akarenga.jp/access/"}>詳しいアクセス方法を見る</LinkButton>
          </TextArea>
          <MapArea>
            <img src={map} alt="横浜赤レンガ倉庫へのアクセス方法" />
          </MapArea>
        </Wrapper>
      </Item>
    </>
  )
}

export default Access